(function () {
  'use strict';
  function matches(card, state) {
    return (state.family === 'all' || card.family === state.family) &&
      (state.color === 'all' || card.color === state.color) &&
      (state.chapter === 'all' || card.chapter === state.chapter) &&
      (!state.stock || card.stock === 'true');
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { matches: matches };
  if (typeof document === 'undefined') return;
  function init(root) {
    if (root.dataset.bexReady) return;
    var controls = root.querySelector('[data-bex-controls]');
    if (!controls) return;
    root.dataset.bexReady = 'true';
    var cards = Array.from(root.querySelectorAll('[data-bex-card]'));
    var family = root.querySelector('[data-bex-family]');
    var color = root.querySelector('[data-bex-color]');
    var chapter = root.querySelector('[data-bex-chapter]');
    var stock = root.querySelector('[data-bex-stock]');
    var count = root.querySelector('[data-bex-count]');
    var empty = root.querySelector('[data-bex-empty]');
    function apply() {
      var state = {family: family.value, color: color.value, chapter: chapter.value, stock: stock.checked};
      var visible = 0;
      cards.forEach(function (card) {
        var show = matches(card.dataset, state);
        card.hidden = !show;
        if (show) visible += 1;
      });
      if (count) count.textContent = 'Showing ' + visible + ' of ' + cards.length + ' artwork editions on this page.';
      if (empty) empty.hidden = visible > 0;
    }
    [family, color, chapter, stock].forEach(function (input) { input.addEventListener('change', apply); });
    root.querySelector('[data-bex-reset]').addEventListener('click', function () {
      family.value = 'all'; color.value = 'all'; chapter.value = 'all'; stock.checked = false; apply();
    });
    controls.hidden = false;
    apply();
  }
  function start(scope) {
    if (scope.matches && scope.matches('[data-bex-catalog]')) init(scope);
    scope.querySelectorAll('[data-bex-catalog]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { start(document); });
  else start(document);
  document.addEventListener('shopify:section:load', function (event) { start(event.target); });
})();
